"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserLookupNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const LookupHelper_1 = require("../LookupHelper");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'USER-LOOKUP';
/**
 * Return User record based on filter.
 */
class UserLookupNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this.asynchronousResolver = async (nodeMap) => {
            var _a, _b, _c, _d;
            const result = {
                exists: false,
                successfulLookup: false,
                result: null,
            };
            const { strategy } = Object.assign({ strategy: this._interfaceDefinition.definitions.ConfigParams.properties.strategy.default }, this.config);
            if ((0, LookupHelper_1.hasStrategyPreReqs)(strategy, (_a = this.accessorMap) === null || _a === void 0 ? void 0 : _a.ONLINE_USER_LOOKUP, (_b = this.accessorMap) === null || _b === void 0 ? void 0 : _b.OFFLINE_USER_LOOKUP)) {
                const { email, username, skipEvaluation } = await this.asynchronousResolveInputs(nodeMap);
                if (!skipEvaluation) {
                    const lookupResult = await (0, LookupHelper_1.lookupUser)((_c = this.accessorMap) === null || _c === void 0 ? void 0 : _c.ONLINE_USER_LOOKUP, (_d = this.accessorMap) === null || _d === void 0 ? void 0 : _d.OFFLINE_USER_LOOKUP, strategy, { email, username });
                    result.exists = !!lookupResult.result;
                    result.successfulLookup = lookupResult.lookupSucceeded;
                    result.result = lookupResult.result;
                }
            }
            return result;
        };
        this.synchronousResolver = (_nodeMap) => {
            throw new Error('User Lookup is not allowed as a synchronously resolving node');
        };
        this._interfaceDefinition = Schema;
    }
    get interfaceDefinition() {
        return Object.assign(Object.assign({}, Schema), { InputParams: this._interfaceDefinition.definitions.InputParams, OutputParams: this._interfaceDefinition.definitions.OutputParams, ConfigParams: this._interfaceDefinition.definitions.ConfigParams });
    }
}
exports.UserLookupNode = UserLookupNode;
UserLookupNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'User Lookup',
    isIdempotent: false,
    primaryCategory: 'Data Lookup',
};
//# sourceMappingURL=UserLookup.js.map